import { useState } from 'react';
import { StateNames, States } from 'src/Screens/Configurator';

interface AdvancedModeProps {
  getValue: <T extends StateNames>(stateName: T) => States[T];
  setValue: <T extends StateNames>(stateName: T, value: States[T]) => void;
  reverse?: boolean;
}

export const AdvancedMode = ({
  getValue,
  setValue,
  reverse = false,
}: AdvancedModeProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const checked = getValue('hasAdvancedMode') as boolean;

  return (
    <div
      className={`flex items-center gap-1.5 mb-1.5 w-fit justify-start ${
        reverse ? 'flex-row-reverse' : 'flex-row'
      }`}
    >
      <span className='text-xs font-normal text-[#344054]'>Mode avancé</span>

      {/* Infobulle */}
      <div className='relative flex items-center'>
        <button
          type='button'
          className='flex items-center justify-center w-4 h-4 rounded-full bg-[#e0d5c5] text-[#344054] text-[10px] font-semibold leading-none cursor-pointer hover:bg-[#BC9A67] hover:text-white transition-colors duration-200'
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={() => setShowTooltip((prev) => !prev)}
          aria-label='Informations sur le mode avancé'
        >
          ?
        </button>
        {showTooltip && (
          <div className='absolute top-full left-1/2 -translate-x-1/2 mt-2 w-52 px-3 py-2 rounded-lg bg-[#344054] text-white text-[11px] leading-snug shadow-lg z-50 pointer-events-none'>
            <div className='absolute bottom-full left-1/2 -translate-x-1/2 w-0 h-0 border-x-[6px] border-x-transparent border-b-[6px] border-b-[#344054]' />
            Le mode avancé permet de ne plus prendre en compte les liaisons
            inter-pièces et d'avoir accès à des configurations moins guidées.
          </div>
        )}
      </div>

      {/* Toggle switch */}
      <button
        type='button'
        role='switch'
        aria-checked={checked}
        onClick={() =>
          setValue('hasAdvancedMode', !checked as States['hasAdvancedMode'])
        }
        className={`relative inline-flex h-[26px] w-[42px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#BC9A67] focus-visible:ring-offset-2 ${
          checked ? 'bg-[#BC9A67]' : 'bg-[#E9E9EA]'
        }`}
      >
        <span
          className={`pointer-events-none inline-block h-[22px] w-[22px] rounded-full bg-white shadow-md ring-0 transition-transform duration-300 ${
            checked ? 'translate-x-4' : 'translate-x-0'
          }`}
        />
      </button>
    </div>
  );
};
